import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

interface RatingProgressData {
	label: string;
	value: number;
}

@Component({
	selector: "app-cbta-ratings-progress-chart",
	standalone: false,
	templateUrl: "./cbta-ratings-progress-chart.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: "./cbta-ratings-progress-chart.component.scss",
})
export class CbtaRatingsProgressChartComponent {
	@Input() data: RatingProgressData[] = [];

	get range(): string[] {
		return ["N/A", "1", "2", "3", "4", "5"];
	}
}
